import { Badge } from '../ui/badge'
import type { ImportCollectionProduct } from './collection-import.types'

const ProductBadges = ({
  product,
}: {
  product: Pick<ImportCollectionProduct, 'isExistingProduct' | 'isInCollection'>
}) => {
  return (
    <div className="flex flex-wrap gap-2">
      {product.isExistingProduct ? (
        <div>
          <Badge variant="secondary" size="sm">
            Product Exists
          </Badge>
        </div>
      ) : (
        <div>
          <Badge variant="success" size="sm">
            New Product
          </Badge>
        </div>
      )}
      {product.isInCollection ? (
        <div>
          <Badge variant="brand" size="sm">
            In Collection
          </Badge>
        </div>
      ) : (
        // Don't show "Not In Collection" if the product is new
        product.isExistingProduct && (
          <div>
            <Badge variant="warning" size="sm">
              Not In Collection
            </Badge>
          </div>
        )
      )}
    </div>
  )
}

export default ProductBadges
